import { Component } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, EmailValidator } from '@angular/forms';
import { StudyContainerPageService } from '../study-container-page/study-container-page.service';
import { StudyFooterComponent } from '../../partials/study-footer/study-footer.component';
import { Observable } from 'rxjs';

@Component({
    selector: 'thank-you-page',
    templateUrl: './thank-you-page.component.html',
    styleUrls: ['./thank-you-page.component.scss']
})
export class ThankYouPageComponent {

    constructor(private studyContainerPageService: StudyContainerPageService) { }


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {

    }






}



// WEBPACK FOOTER //
// ./src/app/pages/thank-you-page/thank-you-page.component.ts